"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "JWT", {
  enumerable: true,
  get: function get() {
    return _jwt.default;
  }
});
var _jwt = _interopRequireDefault(require("./jwt"));